export default "__VITE_ASSET__BuWpcT6c__"